/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Paste_LinkInputs */

const en_import_paste_link = /** @type {(inputs: Import_Paste_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste link from clipboard`)
};

const de_import_paste_link = /** @type {(inputs: Import_Paste_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link aus der Zwischenablage einfügen`)
};

/**
* | output |
* | --- |
* | "Paste link from clipboard" |
*
* @param {Import_Paste_LinkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_paste_link = /** @type {((inputs?: Import_Paste_LinkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Paste_LinkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_paste_link(inputs)
	return en_import_paste_link(inputs)
});